var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDiagonal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.12 120.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}.cls-2{stroke-dasharray:12.55 12.55;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modul_-_Grafik_Vorgang",
    "data-name": "Modul - Grafik / Vorgang"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.34,
    y1: 0.62,
    x2: 91.62,
    y2: 5.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 83.84,
    y1: 15.17,
    x2: 9.92,
    y2: 108.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.03,
    y1: 113.62,
    x2: 2.31,
    y2: 118.33
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 108.06 2 107.9 2.78 117.73 12.53 116.22 12.83 118.2 0.96 120.03 0 108.06"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonal);
export default __webpack_public_path__ + "static/media/ArrowDiagonal.1a5d67edd2084397c08a4b682437f0a2.svg";
export { ForwardRef as ReactComponent };